import { render, staticRenderFns } from "./carregamento.vue?vue&type=template&id=63e15bf6&"
import script from "./carregamento.vue?vue&type=script&lang=js&"
export * from "./carregamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports